<template>
    <label
        class="d-flex align-items-center mb-0"
        :class="cursorClass"
        @click="change"
    >
        <div
            class="switch-container"
            :class="containerClass"
        >
            <div class="switch-handle" />
        </div>

        <span
            v-if="title"
            class="text-gray-dark text-truncate pl-20"
        >
            {{ title }}
        </span>
    </label>
</template>

<script>
export default {
    props: {
        value: Boolean,
        disabled: Boolean,
        title: {
            type: String,
            default: "",
        },
    },

    emits: ["update:value"],

    computed: {
        containerClass() {
            const bgPrimary = this.$css(this.$theme.bgPrimary)
            const bgPrimaryDisabled = this.$css(this.$theme.bgPrimaryDisabled)

            return {
                "bg-gray-medium": !this.value,
                [bgPrimary]: this.value,
                active: this.value,

                [bgPrimaryDisabled]: this.disabled && this.value,
                ...this.cursorClass,
            }
        },

        cursorClass() {
            return {
                "cursor--not-allowed": this.disabled,
                "cursor--pointer": !this.disabled,
            }
        },
    },

    methods: {
        change() {
            if (this.disabled) return
            this.$emit("update:value", !this.value)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "~/scss/bootstrap-importable";

$space: 2 + $border-width;
$handle-width: 32 - (2 * $space);
$handle-height: $handle-width;
$handle-left-position-on: 62 - $handle-width - 2 * $space;

.switch-container {
    border-radius: 32px;
    border: $border-width solid transparent;
    flex-shrink: 0;
    height: 32px;
    padding: 2px;
    width: 62px;
}

.switch-handle {
    background-color: $light;
    border-radius: $handle-width;
    height: $handle-height;
    left: 0;
    position: relative;
    transition: 0.3s;
    width: $handle-width;
}

.active .switch-handle {
    left: $handle-left-position-on;
}
</style>
